const setModalFocus = () => {
  // add all the elements inside modal which you want to make focusable
  const focusableElements = [
    '.big-step-display',
    'select',
    'button',
    '[href]',
    'input',
    'textarea',
    '[tabindex]:not([tabindex="-1"])',
    'label',
    'button',
    '.lead-form-next-step',
  ];
  const modal = document.querySelector('.outer-container-taxi'); // select the modal by it's id
  const startingElement = modal.querySelectorAll(focusableElements)[1]; // get first element to be focused inside modal
  const firstElement = modal.querySelectorAll(focusableElements)[3]; // get first element to be focused inside modal
  const nextStepElement = modal.querySelector('.quiz-navigation .lead-form-next-step');
  const closeBtnElement = modal.querySelector('.btn-close-quiz');

  document.addEventListener('keydown', e => {
    const isTabPressed = e.key === 'Tab' || e.key === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === startingElement) {
        closeBtnElement.focus();
        e.preventDefault();
        return;
      }

      if (document.activeElement === closeBtnElement) {
        nextStepElement.focus();
        e.preventDefault();
        return;
      }
      return;
    }

    // move to first element after closebutton
    if (document.activeElement === closeBtnElement) {
      firstElement.focus();
      e.preventDefault();
      return;
    }

    // move to close button after next step
    if (document.activeElement === nextStepElement) {
      closeBtnElement.focus();
      e.preventDefault();
    }
  });

  startingElement.focus();
};

export default setModalFocus;
